import React, { useState } from "react";
import {
  TextField,
  Button,
  Grid,
  IconButton,
  InputLabel,
  FormControl,
  Typography,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { NotificationManager } from "react-notifications";

const InstrumentDataFileUploader = ({ onGetData }) => {
  const [file, setFile] = useState(null);
  const [batch, setBatch] = useState("");
  const [analyst, setAnalyst] = useState("");
  const [fileName, setFileName] = useState(""); // State for file name

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    const allowedTypes = [
      "application/vnd.ms-excel", // for older Excel formats
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // for .xlsx
      "text/csv" // for CSV files
    ];
  
    if (selectedFile && allowedTypes.includes(selectedFile.type)) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    } else {
      NotificationManager.error("Please upload an Excel or CSV file");
      setFile(null);
      setFileName("");
    }
  };
  

  const handleGetData = () => {
    if (!file || !batch || !analyst) {
      NotificationManager.error("All fields are required");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      onGetData({ fileContent: e.target.result, batch, analyst });
    };
    reader.readAsText(file);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Batch"
          variant="outlined"
          fullWidth
          value={batch}
          onChange={(e) => setBatch(e.target.value)}
          size="small"
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <TextField
          label="Analyst"
          variant="outlined"
          fullWidth
          value={analyst}
          onChange={(e) => setAnalyst(e.target.value)}
          size="small"
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <FormControl fullWidth size="small">
          <InputLabel htmlFor="file-upload" shrink>
            
            {fileName || "Upload File"}
          </InputLabel>
          <input
            accept=".csv, .xlsx"
            style={{ display: "none" }}
            id="file-upload"
            type="file"
            onChange={handleFileChange}
          />
          <label htmlFor="file-upload">
            <IconButton color="primary" component="span">
              <CloudUploadIcon />
            </IconButton>
          </label>
         
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={3}>
        <Button
          variant="contained"
          color="primary"
          size="medium"
          onClick={handleGetData}
          disabled={!file || !batch || !analyst}
          
        >
          Get Data
        </Button>
      </Grid>
    </Grid>
  );
};

export default InstrumentDataFileUploader;
